module.exports = __webpack_public_path__ + "img/real-valladolid-logo-icon.9ce308d2.png";